<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Lopez">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Lopez"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Dr. Cirilo Vázquez Vázquez</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon> cirvaz60@hotmail.com
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> 1
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO:</b>
                        <br>
                        <br>
                        <p></p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            INGENIERO AGRONOMO EN USO Y CONSERVACION DEL AGUA (1984)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            FACULTAD DE AGRICULTURA Y ZOOTECNIA
                            <br>
                            UNIVERSIDAD JUAREZ DEL ESTADO DE DURANGO
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>ADMINISTRACION DE LOS RECURSOS AGUA SUELO (1992)</li>
                            <p>
                                ITA No. 10
                            </p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>DOCTORADO EN CIENCIAS EN MANEJO SUSTENTABLE DE LOS RECURSOS NATURALES EN ZONAS ARIDAS Y SEMIARIDAS (2003)</li>
                            <p>
                                FACULTAD DE AGRICULTURA Y ZOOTECNIA
                                <br>
                                UNIVERSIDAD JUAREZ DEL ESTADO DE DURANGO
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>FERTILIDAD DE SUELOS</li>
                        </ul>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>MÁS INFORMACIÓN.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon" class="pb-1">
                        <v-btn color="blue" @click="info = false; mostrarPublicaciones = true" text>Publicaciones</v-btn>
                        <br>
                        <v-btn color="blue" @click="info = false; mostrarProyectos = true" text>Proyectos</v-btn>
                    </div>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarPublicaciones == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PUBLICACIONES.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarPublicaciones = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headers" :items="Tabla" group-by="categoria"  item-key="numero"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarProyectos == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PROYECTOS.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarProyectos = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headersProy" :items="tablaProyectos" item-key="nombre"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/vazquez.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
            mostrarPublicaciones: false,
            mostrarProyectos: false,
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'numero',
                },
                { text: 'TÍTULO', value: 'titulo' },
                { text: 'AÑO PUBLICACIÓN', value: 'publicacion' },
            ],
            Tabla: [
                {
                    numero: 1,
                    titulo: 'Effect of Seaweed Aqueous Extracts an Compost on Vegetative Growth, Yield, and Nutraceutical Quality of Cucumber (Cucumis sativus L.) Fruit',
                    publicacion: 2018,
                    categoria: 'Articulo'
                },
                {
                    numero: 2,
                    titulo: 'Rendimiento de chile jalapeño con lixiviado de lombriz con dos métodos de riego.Fruit yield of jalapeno pepper with worm leachate and two irrigation methods.',
                    publicacion: 2018,
                    categoria: 'Articulo'
                },
                {
                    numero: 3,
                    titulo: 'Diagnóstico de nutrimento compuesto e interacciones nutrimentales en chile jalapeño (Capsicum annuum L.) en suelos semiáridos. Compositional nutrientes diagnosis and nutrimental interactions in Jalapeño pepper (Capsicum annuum L.) in semiarids soils.',
                    publicacion: 2017,
                    categoria: 'Articulo'
                },
                {
                    numero: 4,
                    titulo: 'Estiércol solarizado y dos métodos de riego en la producción de chile jalapeño (Capsicum annuum L. var.annuum) Solarized manure and two irrigation methods on fruit yield of jalapeno chili (Capsicum annuum L. var. Annuum).',
                    publicacion: 2017,
                    categoria: 'Articulo'
                },
                {
                    numero: 5,
                    titulo: 'Relación de dÍeldrin y propiedades del suelo en la Comarca Lagunera, México. Relationship of dieldrin and soil properties in Comarca Lagunera, México.',
                    publicacion: 2017,
                    categoria: 'Articulo'
                },
                {
                    numero: 6,
                    titulo: 'Polimorfismos del gen ob en bovinos de raza holstein en la Comarca Lagunera, México. Ob Gene Polymorphisms in Holstein Cattle al Comarca Lagunera, México.',
                    publicacion: 2017,
                    categoria: 'Articulo'
                },
                {
                    numero: 7,
                    titulo: 'Normas nutrimentales preliminares para un cultivar criollo de Capsicum annuum con base en la técnica de diagnóstico de nutrimento compuesto.',
                    publicacion: 2017,
                    categoria: 'Articulo'
                },
                {
                    numero: 8,
                    titulo: 'Parámetros de estabilidad en híbridos de girasol con alto contenido de oleico.',
                    publicacion: 2017,
                    categoria: 'Articulo'
                },
                {
                    numero: 9,
                    titulo: 'Acetilicolinesterasa de Eisenia foetida como indicador de contaminación por plaguicidas organofosforados.',
                    publicacion: 2017,
                    categoria: 'Articulo'
                },
                {
                    numero: 10,
                    titulo: 'Determinación preliminar de normas e interacciones nutrimentales en chile ancho (Capsicum annuum) en la Comarca Lagunera. Preliminary determination of nutrient norms and nutrient interactions on pepper "ancho" (Capsicum annuum) in the Comarca Lagunera.',
                    publicacion: 2016,
                    categoria: 'Articulo'
                },
            ],
            headersProy: [
                {
                    text: 'NOMBRE DEL PROYECTO',
                    align: 'start',
                    sortable: false,
                    value: 'nombre',
                },
                { text: 'TIPO DE FINANCIAMIENTO', value: 'tipo' },
            ],
            tablaProyectos: [
                {
                    nombre: 'PRODUCCION DE MELON CHINO EN MICROTUNEL CON HULE SIN ALBEDO Y ACOLCHADO PLASTICO EN LA LAGUNA.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'RESPUESTA DE DOS VARIEDADES CONVENCIONALES DE ALGODONERO (Gossypium hirsitum L.) A LA FERTILIZACION ORGANICA UTILIZANDO RIEGO POR GOTEO.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'ALTERNATIVAS DE FORRAJES EN INVIERNO, DOS VARIEDADES DE TRITICALE.',
                    tipo: 'INTERNO'
                },
            ]
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
